import React from "react";
import { usePutSegmentFindFilterQuery } from "@tiny/api";
import { useRefreshRegister } from "@tiny/components/src/RefreshProvider";
import {
  isRecommendedSegment,
  isLibrarySegment,
  segmentView2Card,
  isDeliverySegment,
} from "./PredefinedSegments.helpers";

function usePredefinedSegments() {
  const {
    data: { content: data = [], totalElements: totalCount } = {},
    isFetched,
    refetch: refetchPredefinedSegments,
  } = usePutSegmentFindFilterQuery(
    {
      segmentTypes: [
        "PREDEFINED_RECOMMENDED",
        "PREDEFINED_LIBRARY",
        "PREDEFINED_DELIVERY",
      ],
    },
    {
      page: 0,
      size: 50,
      sort: ["updatedAt", "DESC"],
      countAllCustomers: false,
    },
    {
      keepPreviousData: true,
    }
  );

  const recommendedSegments = React.useMemo(() => {
    return data.filter(isRecommendedSegment).map(segmentView2Card);
  }, [data]);

  const librarySegments = React.useMemo(() => {
    return data.filter(isLibrarySegment).map(segmentView2Card);
  }, [data]);

  const deliverySegments = React.useMemo(() => {
    return data.filter(isDeliverySegment).map(segmentView2Card);
  }, [data]);

  useRefreshRegister(async () => {
    await refetchPredefinedSegments();
  });

  return {
    isFetched,
    totalCount,
    recommendedSegments,
    librarySegments,
    deliverySegments,
  };
}

export { usePredefinedSegments };
